import { BaseService } from "./common/base";
import type { Integration } from "../../../../api/src/integration/entities/integration.entity";
import type { IntegrationType } from "../../../../api/dist/src/integration/integration.service";

export class IntegrationService extends BaseService<Integration> {
  constructor() {
    super("integration");
  }

  authorizationUrl(integrationType: IntegrationType) {
    return this._get(`${integrationType}/authorization-url`);
  }

  authorizationCallback(integrationType: IntegrationType, token: string) {
    return this._post(`${integrationType}/authorization-callback`, {
      token,
    });
  }

  sync(integrationId: string) {
    return this._post(`${integrationId}/sync`);
  }
}
